import '../../reset.css';
import '../../general_styles.css';
import './plan_styles.css';

import NavigationMenu from '../../components/Navigation';
import Titleform from '../../components/Title_form';
import BtnTransition from '../../components/Buttons_Transition';

import arcadeImg from '../../images/icon-arcade.svg';
import advancedImg from '../../images/icon-advanced.svg';
import proImg from '../../images/icon-pro.svg';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { FormValueContext } from '../../contexts/formValues';
import { useContext } from 'react';

function Plan() {

    const { inputArcade, setInputArcade, inputAdvanced, setInputAdvanced, inputPro, setInputPro, isYearly, setIsYearly, textPlan, setTextPlan, totalPrice, setTotalPrice, textPricePlan, setTextPricePlan } = useContext(FormValueContext);

    const navigate = useNavigate();


    /*     useEffect(() => {
            if (inputArcade) {
                setInputAdvanced(false);
                setInputPro(false);
            }
            if (inputAdvanced) {
                setInputArcade(false);
                setInputPro(false);
            } if (inputPro) {
                setInputArcade(false);
                setInputAdvanced(false);
            }
        }, [inputArcade, inputAdvanced, inputPro]); */


    const clickCheckArcade = () => {
        setInputAdvanced(false);
        setInputPro(false);
    };

    const clickCheckAdvanced = () => {
        setInputArcade(false);
        setInputPro(false);
    };

    const clickCheckPro = () => {
        setInputAdvanced(false);
        setInputArcade(false);
    };

    const submitPlan = (e) => {
        e.preventDefault();
        if (isYearly) {
            if (inputArcade) {
                console.log('AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA');
                setTextPlan('Arcade');
                setTextPricePlan(90);
            } else if (inputAdvanced) {
                setTextPlan('Advanced');
                setTextPricePlan(120);
            } else if (inputPro) {
                setTextPlan('Pro');
                setTextPricePlan(150);
            }
        } else {
            if (inputArcade) {
                console.log('AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA');
                setTextPlan('Arcade');
                setTextPricePlan(9);
            } else if (inputAdvanced) {
                setTextPlan('Advanced');
                setTextPricePlan(12);
            } else if (inputPro) {
                setTextPlan('Pro');
                setTextPricePlan(15);
            }
        }

        navigate('/addons');
    }


    return (
        <div className='page__container'>
            <div className='form__container'>
                <NavigationMenu />
                <form className='form' onSubmit={(e) => submitPlan(e)}>
                    <Titleform title='Select your plan' text='You have the option of monthly or yearly billing' />
                    <div className='form__yourplan'>
                        <div className='plans__container'>
                            <input type='checkbox' id='arcade_input' checked={inputArcade} onChange={() => { setInputArcade(true); clickCheckArcade(); }} />
                            <label style={{ 'borderColor': `${inputArcade ? 'hsl(213, 96%, 18%)' : 'hsl(231, 11%, 63%)'}` }} className='cardplan' htmlFor='arcade_input'>
                                <img src={arcadeImg}></img>
                                <div className='cardplan__text'>
                                    <h3 className='cardplan__title'>Arcade</h3>
                                    <p className='cardplan__price'>{`${isYearly ? '$90/yr' : '$9/mo'}`}</p>
                                    <p className='cardplan__promo' style={{ 'display': `${isYearly ? 'block' : 'none'}` }}>2 months free</p>
                                </div>
                            </label>
                            <input type='checkbox' id='advanced_input' checked={inputAdvanced} onChange={() => { setInputAdvanced(true); clickCheckAdvanced(); }} />
                            <label style={{ 'borderColor': `${inputAdvanced ? 'hsl(213, 96%, 18%)' : 'hsl(231, 11%, 63%)'}` }} className='cardplan' htmlFor='advanced_input'>
                                <img src={advancedImg}></img>
                                <div className='cardplan__text'>
                                    <h3 className='cardplan__title'>Advanced</h3>
                                    <p className='cardplan__price'>{`${isYearly ? '$120/yr' : '$12/mo'}`}</p>
                                    <p className='cardplan__promo' style={{ 'display': `${isYearly ? 'block' : 'none'}` }}>2 months free</p>
                                </div>
                            </label>
                            <input type='checkbox' id='pro_input' checked={inputPro} onChange={() => { setInputPro(true); clickCheckPro(); }} />
                            <label style={{ 'borderColor': `${inputPro ? 'hsl(213, 96%, 18%)' : 'hsl(231, 11%, 63%)'}` }} className='cardplan' htmlFor='pro_input'>
                                <img src={proImg}></img>
                                <div className='cardplan__text'>
                                    <h3 className='cardplan__title'>Pro</h3>
                                    <p className='cardplan__price'>{`${isYearly ? '$150/yr' : '$15/mo'}`}</p>
                                    <p className='cardplan__promo' style={{ 'display': `${isYearly ? 'block' : 'none'}` }}>2 months free</p>
                                </div>
                            </label>
                        </div>
                        <div className='plans__switch'>
                            <span>Monthly</span>
                            <label class="switch">
                                <input type="checkbox" checked={isYearly} onChange={(e) => { setIsYearly(!isYearly); console.log(isYearly); }}></input>
                                <span class="slider round"></span>
                            </label>
                            <span>Yearly</span>
                        </div>
                    </div>
                    <BtnTransition hasBackBtn={true} goToBack='/' hasNextBtn={true} />
                </form>
            </div>

        </div>
    );
}

export default Plan;